const _ = require("lodash");

const getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const getValueByLang = (language = "th-TH") => (
  data = {},
  propsName = "name",
  defaultValue = ""
) => {
  const langPrefix = language.includes("th") ? "_th" : "_en";
  return _.get(data, `${propsName}${langPrefix}`, defaultValue);
};

const t = (thai, eng) => {
  return getCookie("i18next") === "th-TH" ? thai : eng;
};

const lang = () => {
  return getCookie("i18next") === "th-TH" ? "th" : "en";
};

module.exports = {
  getValueByLang,
  t,
  lang,
};
